import { useQuery } from '@tanstack/react-query'
import { type components } from '../types/prove-v1'
import { throwOnError } from '../utils/throwOnError'
import { useAuth } from './useAuth'

export type Slakteri = components['schemas']['Slakteri']

const MAX_EFTA_NUMBERS_PER_REQUEST = 100

const chunk = <T>(values: T[], size: number) =>
  Array.from({ length: Math.ceil(values.length / size) }, (_, index) =>
    values.slice(index * size, (index + 1) * size)
  )

export const useGetSlakterierQuery = (eftanummer: string[], enabled = true) => {
  const { authFetch } = useAuth()
  const uniqueEftanummer = [
    ...new Set(
      eftanummer
        .map((value) => value.trim())
        .filter((value) => /^\d+$/.test(value))
    )
  ].sort((a, b) => a.localeCompare(b, 'nb-NO', { numeric: true }))

  return useQuery({
    queryKey: ['slakterier', uniqueEftanummer],
    enabled: enabled && uniqueEftanummer.length > 0,
    retry: false,
    queryFn: async () => {
      const responses = await Promise.all(
        chunk(uniqueEftanummer, MAX_EFTA_NUMBERS_PER_REQUEST).map(
          async (eftanummerBatch) => {
            const { data, error } = await authFetch().GET('/slakterier', {
              params: { query: { eftanummer: eftanummerBatch } }
            })
            if (error) throwOnError(error)
            return data ?? []
          }
        )
      )

      return responses.flat()
    }
  })
}
